// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"1fbfbd9f","356":"cbd4573f","438":"bda93984","465":"2bbb07b7","538":"d1a77b24","912":"879a18d2","954":"c9ef1aaa"}[chunkId] + ".chunk.js";
};